import { ArrowLeft } from "lucide-react";

interface BackButtonProps {
  onClick: () => void;
}

export function BackButton({ onClick }: BackButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="mb-4 flex items-center gap-2 text-[14px] leading-[1.4] text-[#58534c] hover:text-[#1f1e1d]"
    >
      <ArrowLeft className="h-5 w-5" />
      Back
    </button>
  );
}
